import React, { useState } from 'react'
import { CreateCitiesPermission } from '../../constants/permissions';
import { usePermission } from '../../hooks/usePermission';
import CitiesTable from '../../Components/Cities/CitiesTable';
import CityForm from '../../Components/Cities/CityForm';
import { Box, Container, Paper, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function Cities() {
  const { data: canCreateCity} = usePermission({
    permissionName: CreateCitiesPermission,
  });

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    country_id: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({
      name: "",
      country_id: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
          <Typography variant="h4" component="h1">
            Cities
          </Typography>
          {canCreateCity && (
            <button
              className="bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2"
              onClick={handleClickOpen}
            >
              <AddIcon />
              Add New City
            </button>
          )}
        </Box>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <CitiesTable />
        </Paper>

        <CityForm
          open={open}
          onClose={handleClose}
          formData={formData}
          onInputChange={handleInputChange}
        />
      </Box>
    </Container>
  );
}

export default Cities